import React, { useEffect, useState } from "react";
import { Volume2, VolumeX } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { isMuted, onMutedChange, setMuted } from "@/lib/trollSound";

// Small floating speaker: above the SOS pill on phones (clear of the install bar), beside it on desktop.
export default function SoundToggle() {
  const { t } = useLang();
  const [muted, setState] = useState(isMuted);
  useEffect(() => onMutedChange(setState), []);
  const label = muted ? t.sound.unmute : t.sound.mute;
  const Icon = muted ? VolumeX : Volume2;
  return (
    <button
      type="button"
      data-testid="sound-toggle"
      data-muted={muted ? "true" : "false"}
      aria-pressed={!muted}
      aria-label={label}
      title={label}
      onClick={() => setMuted(!muted)}
      className="fixed left-3 bottom-12 md:left-[4.25rem] md:bottom-4 z-50 w-7 h-7 grid place-items-center rounded-full bg-paper border border-line text-ink shadow-journal transition-[background-color,transform] duration-200 hover:scale-110 hover:bg-parchment before:absolute before:-inset-2 before:content-['']"
    >
      <Icon className="w-3.5 h-3.5" />
    </button>
  );
}
